<template>
    <div class="swiper-container swiper-slider">
        <!-- Additional required wrapper -->
        <div class="swiper-wrapper swiper-slider--wrapper">
            <div class="swiper-slide swiper-slider--slide" v-for="(item, index) in items" :key="index">
                <slot v-bind="item"/>
            </div>
        </div>
        <!-- If we need pagination -->
        <div class="swiper-pagination swiper-slider--pagination"/>

        <!-- If we need navigation buttons -->
        <base-btn class="swiper-slider--nav swiper-slider--nav__prev"
                size="medium"
                :facets="['bubble', buttonColorFacet]">
            <base-icon class="swiper-slider--icon" symbol="chevron-left" size="medium"/>
        </base-btn>
        <base-btn class="swiper-slider--nav swiper-slider--nav__next"
                size="medium"
                :facets="['bubble', buttonColorFacet]">
            <base-icon class="swiper-slider--icon" symbol="chevron-right" size="medium"/>
        </base-btn>
    </div>
</template>

<script>
    import { DEFAULT_THEME } from 'constants/themes';
    import { mapState } from 'vuex';
    import Swiper from 'swiper';

    export default {
        props: {
            items: {
                type: Array,
                required: true,
            },
            options: {
                type: Object,
                default() {
                    return {};
                },
            },
        },
        computed: {
            ...mapState('page', ['theme']),
            buttonColorFacet() {
                return this.theme === DEFAULT_THEME ? 'primary' : 'primary-inverted';
            },
        },
        mounted() {
            this.swiper = new Swiper(this.$el, {
                // If we need pagination
                pagination: {
                    el: '.swiper-slider--pagination',
                },

                // Navigation arrows
                navigation: {
                    nextEl: '.swiper-slider--nav__next',
                    prevEl: '.swiper-slider--nav__prev',
                },
                ...this.options,
            });
        },
        beforeDestroy() {
            this.swiper.destroy();
        },
    };
</script>
